import elementLocale from 'element-ui/lib/locale/lang/en'
export default {
  floorplanEvaluation: {
    entry: "Évaluation du plan",
    aiResultOnly: "L’évaluation utilise le dernier résultat de conception architecturale IA réussi de ce projet. Les modifications dans l’éditeur sont exclues, enregistrées ou non.",
    running: "Évaluation du plan / chargement des résultats",
    previousVersion: "Ce rapport concerne un résultat de conception architecturale IA antérieur, ou sa version ne peut être confirmée.",
    total: "Score total",
    normalized: "Score sur 100",
    objective: "Score objectif",
    subjective: "Score subjectif",
    details: "Détails de l’évaluation",
    empty: "Aucune évaluation terminée",
    refresh: "Actualiser",
    start: "Lancer l’évaluation",
    failed: "Échec de l’évaluation. Veuillez réessayer.",
    OBJ_01: "Types et nombre de pièces",
    OBJ_03: "Conformité aux dimensions MyBox",
    OBJ_06: "Alignement des escaliers",
    OBJ_07: "Contact des pièces principales avec les murs extérieurs",
    functional_zoning: "Répartition fonctionnelle",
    circulation_organization: "Circulation",
    privacy: "Intimité",
    spatial_comfort: "Confort spatial"
  },
  common: {
    appName: 'MH House',
    home: 'Accueil',
    login: 'Connexion',
    workspace: 'Espace de travail',
    logout: 'Déconnexion',
    notFound: 'Page introuvable',
    backHome: "Retour à l'accueil",
    cancel: 'Annuler',
    confirm: 'Confirmer',
    apply: 'Appliquer',
    close: 'Fermer',
    all: 'Tout',
    user: 'Utilisateur',
    updated: 'Mis à jour',
    project: 'Projet'
  },
  nav: {
    wallet: 'Portefeuille',
    changePassword: 'Modifier le mot de passe',
    titles: {
      projectsStructure: 'Projets structure',
      houseDesign: 'Détails du projet',
      architecturePlan: 'Plan architectural',
      structureDesign: 'Conception structurelle',
      structureCalculation: 'Calcul structurel',
      designReport: 'Rapport de conception'
    }
  },
  home: {
    title: 'MH House WebUI',
    subtitle: 'Une base front-end propre prête pour le nouveau projet.',
    openWorkspace: "Ouvrir l'espace de travail"
  },
  login: {
    title: 'Connexion',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    submit: 'Se connecter',
    placeholder: 'Point de terminaison de connexion provisoire. À remplacer lorsque le backend sera prêt.'
  },
  workspace: {
    title: 'Espace de travail',
    subtitle: 'Page provisoire de route protégée.'
  },
  projects: {
    searchPlaceholder: 'Rechercher un projet',
    empty: 'Aucun projet',
    fetchFailed: 'Échec du chargement des projets',
    missingIdempotencyKey: "Clé d'idempotence manquante pour ce projet",
    projectFallback: 'Projet {id}',
    newProject: 'Nouveau projet',
    createDialogTitle: 'Nouveau projet',
    createDialogPlaceholder: 'Saisissez le nom du projet',
    createNameRequired: 'Le nom du projet est requis',
    createFailed: 'Échec de la création du projet',
    createConfirm: 'Créer',
    manageProjects: 'Gérer les projets',
    exitManage: 'Quitter la gestion',
    deleteSelected: 'Supprimer ({count})',
    deleteConfirmTitle: 'Supprimer les projets',
    deleteConfirmMessage: 'Supprimer les {count} projet(s) sélectionné(s) ? Cette action est irréversible.',
    deleteConfirmButton: 'Supprimer',
    deleteSuccess: '{count} projet(s) supprimé(s)',
    deleteFailed: 'Échec de la suppression des projets'
  },
  houseDesign: {
    backToProjects: 'Retour aux projets',
    pageTitle: 'Détails du projet',
    pageTitleWithKey: 'Détails du projet - {key}',
    idempotencyKey: "Clé d'idempotence : {key}",
    missingKey: "Clé d'idempotence manquante. Veuillez entrer depuis la liste des projets.",
    progressTitle: 'Progression du projet',
    enterStepTitle: 'Entrer dans une étape',
    enterStep: 'Entrer dans {step}',
    stepStatus: {
      completed: 'Terminé',
      current: 'Étape actuelle',
      pending: 'En attente'
    },
    steps: {
      architecturePlan: 'Plan architectural',
      structureDesign: 'Conception structurelle',
      structureCalculation: 'Calcul structurel',
      designReport: 'Rapport de conception'
    }
  },
  constraints: {
    back: 'Retour au projet',
    title: 'Indiquez votre budget et la largeur de façade',
    budget: {
      title: 'Budget'
    },
    frontage: {
      title: 'Largeur (間口)',
      meters: 'env. {meters} m'
    },
    recommendFailed: 'Les recommandations sont temporairement indisponibles. Veuillez réessayer.',
    next: 'Suivant'
  },
  structureDesign: {
    generating: 'Génération...',
    back: 'Retour',
    title: 'Conception IA de maison individuelle',
    subtitle: 'Éditeur de conception · {name}',
    undo: 'Annuler',
    redo: 'Rétablir',
    save: 'Enregistrer',
    saveToStorage: 'Enregistrer',
    exportToFile: 'Exporter vers un fichier',
    exportProjectJson: 'Exporter le JSON du projet',
    exportCadJson: 'Exporter le JSON CAD',
    cadExport: {
      warningTitle: 'Avertissements de validation CAD',
      warningMessage: 'Le JSON CAD contient des avertissements de validation. Vous pouvez toujours le télécharger, mais la livraison n’est pas entièrement vérifiée.',
      continue: 'Exporter quand même',
      fatal: 'Le plan contient une géométrie CAD non valide et ne peut pas être exporté.',
      failed: 'Échec de l’export du JSON CAD. Veuillez réessayer.',
      exported: 'JSON CAD exporté : {fileName}',
      annotationsSaveFailed: 'Les annotations de cote ont été exportées, mais n’ont pas pu être enregistrées dans ce projet.',
      issueCategories: {
        geometry: 'Avertissement de validation géométrique ({code})',
        annotations: 'Avertissement de validation des annotations ({code})',
        structure: 'Avertissement de validation de la structure IA ({code})'
      }
    },
    load: 'Charger',
    project: 'Projet',
    tools: 'Outils',
    select: 'Sélectionner',
    sampleRoom: 'Pièce exemple',
    catalog: 'Catalogue',
    searchCatalog: 'Rechercher dans le catalogue',
    designAssetRoomFilter: 'Pièce',
    designAssetStyleFilter: 'Style',
    designAssetRooms: {
      kitchen: 'Cuisine',
      bathroom: 'Salle de bains',
      washroom: 'Salle d’eau',
      outdoor: 'Extérieur',
      'living-dining': 'Salon / Salle à manger',
      'master-bedroom': 'Chambre parentale',
      'kids-room': 'Chambre d’enfant'
    },
    designAssetStyles: {
      'white-model': 'Modèle blanc',
      natural: 'Naturel',
      'simple-modern': 'Moderne simple',
      japandi: 'Japandi',
      vintage: 'Vintage'
    },
    catalogFilterEmpty: 'Aucun élément correspondant',
    catalogFilterClear: 'Effacer les filtres',
    catalogFilterLoading: 'Filtrage…',
    catalogFilterBack: 'Retour aux catégories',
    catalogFilterToggle: 'Afficher ou masquer les filtres',
    properties: 'Propriétés',
    settings: 'Réglages',
    projectConfiguration: 'Configuration du projet',
    aiDesign: 'Paramètres de conception IA',
    generate: 'Générer la conception',
    view2d: 'Vue 2D',
    view3d: 'Vue 3D',
    switchTo3d: 'Cliquer pour afficher la 3D dans la vue principale',
    switchTo2d: 'Cliquer pour afficher la 2D dans la vue principale',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    fitView: 'Ajuster au canevas',
    openCatalog: 'Ouvrir le catalogue',
    export: 'Exporter',
    exportChooseFormat: "Choisir le format d'export",
    import: 'Importer',
    developing: 'En développement',
    catalogTitle: 'Catalogue des éléments',
    catalogHint: 'Sélectionnez un élément, puis cliquez sur le canevas 2D pour le placer',
    catalogAvailable: '{count} éléments disponibles',
    catalogEmptyTitle: 'Aucun élément correspondant',
    catalogEmptyHint: 'Essayez une autre catégorie ou un autre mot-clé',
    catalogFooter: 'Catalogue / {category}',
    clearSearch: 'Effacer la recherche',
    inspectorDeveloping: 'Cette section est en cours de développement',
    selectionSummary: '{count} éléments sélectionnés',
    emptyState: 'Sélectionnez un élément ou choisissez un élément du catalogue, puis modifiez sur le canevas.',
    editorToolbar: {
      label: 'Commandes éditeur',
      file: 'Fichier',
      clear: 'Effacer',
      ai: 'IA',
      pdf: 'Export PDF',
      html: 'Export HTML',
      share: 'Partager',
      clearConfirmTitle: 'Effacer le plan',
      clearConfirmMessage: 'Cela effacera le plan actuel. Continuer ?',
      placeholderNotice: 'Cette commande sera connectée dans un module ultérieur. Placeholder uniquement.'
    },
    clearScene: {
      success: 'Plan effacé avec succès',
      failed: 'Échec de l\'effacement du plan. Veuillez réessayer.'
    },
    drawingUnderlay: {
      title: 'Fond de plan',
      show: 'Afficher le fond de plan',
      hide: 'Masquer le fond de plan',
      opacity: 'Opacité du fond de plan',
      elementOpacity: 'Opacité des éléments'
    },
    viewSettings: {
      title: 'Réglages de la vue 3D',
      daylight: 'Ensoleillement',
      daylightSlider: 'Heure de la journée',
      presets: {
        morning: 'Matin',
        midday: 'Midi',
        evening: 'Soir',
        night: 'Nuit'
      },
      ceilingHeight: 'Hauteur sous plafond',
      sectionCut: 'Coupe',
      sectionCutHint: 'Masque tout ce qui dépasse la hauteur de coupe.'
    },
    editorToolGroups: {
      draw: 'Pièces / murs',
      openings: 'Portes / fenêtres',
      structure: 'Structure',
      furnishings: 'Ameublement'
    },
    editorToolPanels: {
      drawHouse: 'Plan',
      layout: 'Mobilier et matériaux'
    },
    camera: {
      tool: "Caméra",
      renderTool: "Rendu",
      renderTitle: "Rendu",
      renderRecaptureHint: "Recapturer depuis la position actuelle de la caméra",
      previewTitle: "Caméra {index} · Vue 3D",
      openComposition: "Ajuster le cadrage",
      previewHint: "Cliquez pour ajuster le cadrage",
      placingHint: "Cliquez sur le plan pour placer la caméra",
      addOverhead: "Vue 3D plongeante",
      addOverheadHint: "Ajouter une caméra qui surplombe le bâtiment",
      overheadBadge: "Plongée",
      overheadHint: "Vue plongeante sur l’étage sélectionné.",
      compositionFromPreview: "Ajustez le cadrage dans la vue 3D en haut à droite.",
      place: "Placer une caméra",
      panelTitle: "Caméras",
      empty: "Aucune caméra. Placez-en une sur le plan",
      limitReached: "{max} caméras maximum",
      item: "Caméra {index}",
      position: "Position",
      elevation: "Hauteur",
      yaw: "Orientation",
      pitch: "Inclinaison",
      fov: "Champ de vision",
      remove: "Supprimer la caméra",
      enterComposition: "Cadrage 3D",
      clampedTo: "Limité à {value}",
      readonlyHint: "Projet en lecture seule ; caméras non modifiables",
      lockedWhileRendering: "Rendu en cours. Les caméras ne sont pas modifiables.",
      compositionTitle: "Cadrage 3D · Caméra {index}",
      compositionDone: "Terminer",
      compositionCancel: "Annuler",
      compositionHint: "Glissez pour pivoter, molette pour zoomer. Le cadre correspond au rendu final.",
      compositionAspect: "16:9 (identique au ratio de sortie)",
      compositionDegraded: "Fenêtre trop petite ; le cadre est affiché réduit",
      batchEntry: "Rendu par lot",
      batchViewResults: "Voir les rendus",
      batchFromCameras: "Rendu depuis {count} caméras",
      batchTitle: "Rendu par lot",
      batchNew: "Nouveau rendu",
      batchHistoryEmpty: "Aucun rendu pour le moment. Lancez-en un depuis le panneau caméra à droite.",
      batchFailedUnknown: "Échec du rendu ; aucune raison renvoyée. Veuillez réessayer.",
      batchFailedTimeout: "Rendu expiré. Veuillez réessayer.",
      batchCaptureBusy: "La capture précédente n'est pas terminée. Veuillez patienter.",
      batchPreviousResult: "Tour précédent",
      batchCameraNoResult: "Aucun résultat pour l'instant",
      batchCameraRemoved: "Caméra supprimée ; ses résultats sont conservés",
      batchRowSatisfied: "Objectif atteint — non généré ce tour",
      batchStepConfig: "Configuration",
      batchStepCapture: "Vérifier les vues",
      batchCaptureConfirm: "Vérifiez le cadrage de chaque caméra ; relancez la capture si nécessaire.",
      batchCaptureZoom: "Cliquer pour agrandir",
      batchRecapture: "Recapturer",
      batchCaptureNext: "Continuer avec {count} images",
      batchCaptureAllFailed: "Toutes les captures ont échoué. Ajustez les positions des caméras et réessayez.",
      batchStepRender: "Rendu",
      batchTarget: "Images cibles par caméra",
      batchStyle: "Style",
      batchStylized: "Rendu",
      batchResolution: "Résolution",
      batchPromptPlaceholder: "Instructions supplémentaires (facultatif)",
      batchStartFailed: "Échec du démarrage du rendu. Veuillez réessayer plus tard.",
      batchGenerate: "Générer {count} image(s)",
      batchAllSatisfied: "Toutes les caméras sont satisfaites",
      batchNoCameras: "Placez d'abord une caméra sur le plan",
      batchAdopt: "Adopter",
      batchAdopted: "Adoptées {n}/{k}",
      batchSatisfied: "Satisfaite {k}/{k}",
      batchStale: "La caméra {index} a été déplacée ; ses {n} image(s) adoptée(s) ne comptent plus",
      batchCapturing: "Capture {i}/{n}",
      batchSubmitting: "Envoi {i}/{n} — ne quittez pas la page",
      batchQueued: "En attente",
      batchPendingCapture: "En attente de capture",
      batchCaptured: "Capturé, non soumis",
      batchRunning: "Génération",
      batchDone: "Terminé",
      batchFailed: "Échec",
      batchRetry: "Réessayer",
      batchSkip: "Ignorée",
      batchUnsupported: "Le backend ne peut pas encore générer {n} images d'un coup — mettez à jour le service api",
      batchInvalid: "Indisponible",
      batchClose: "Fermer",
    },
    editorToolSections: {
      stair: 'Escaliers',
      accessory: 'Accessoires',
      material: 'Matériaux',
      furniture: 'Mobilier',
      lighting: 'Éclairage',
      builtin: 'Aménagements',
      appliance: 'Électroménager',
      equipment: 'Équipements'
    },
    editorToolCategories: {
      stairStairs: 'Escaliers',
      accessoryClocks: 'Horloges',
      accessoryMirrors: 'Miroirs',
      accessoryCushions: 'Coussins',
      accessoryArt: 'Art et déco murale',
      accessoryPlants: 'Plantes',
      accessoryOther: 'Autres',
      furnitureDiningTables: 'Tables à manger',
      furnitureDesks: 'Bureaux',
      furnitureDoubleBeds: 'Lits doubles',
      furnitureSingleBeds: 'Lits simples',
      furnitureRugs: 'Tapis',
      furnitureOther: 'Autres',
      lightingPendant: 'Suspensions',
      lightingDown: 'Spots encastrés',
      lightingSpot: 'Projecteurs',
      lightingStand: 'Lampadaires et lampes',
      lightingBracket: 'Appliques',
      lightingOther: 'Autres',
      builtinCounter: 'Comptoirs',
      builtinShelf: 'Étagères',
      builtinPillowShelf: 'Étagères de tête de lit',
      builtinStorage: 'Rangements',
      builtinEntranceStorage: 'Rangements d’entrée',
      builtinOther: 'Autres',
      applianceRefrigerator: 'Réfrigérateurs',
      applianceTv: 'Téléviseurs',
      applianceWasher: 'Lave-linge',
      applianceDryer: 'Sèche-linge',
      applianceMicrowave: 'Micro-ondes',
      applianceVacuum: 'Aspirateurs',
      applianceOther: 'Autres',
      equipmentKitchen: 'Cuisines',
      equipmentCupboard: 'Placards de cuisine',
      equipmentToilet: 'WC',
      equipmentWashbasin: 'Lavabos',
      equipmentBathtub: 'Baignoires',
      equipmentWasher: 'Lave-linge',
      equipmentWaterHeater: 'Chauffe-eau',
      equipmentAirConditioner: 'Climatiseurs',
      equipmentSwitch: 'Interrupteurs',
      equipmentOther: 'Autres',
      furnitureKitchen: 'Cuisines',
      furnitureToilet: 'Toilettes',
      furnitureBathroom: 'Salles de bains',
      furnitureWashbasins: 'Meubles vasques',
      furnitureAppliances: 'Électroménager',
      furnitureAirConditioning: 'Climatisation',
      furnitureWaterHeating: 'Chauffe-eau',
      walls: 'Murs',
      doorWindow: 'Portes / fenêtres',
      holes: 'Ouvertures',
      structure: 'Structure',
      stairs: 'Escaliers',
      furniture: 'Mobilier',
      kitchenBath: 'Cuisine / bain',
      furnitureSofa: 'Canapés',
      furnitureTables: 'Tables / bureaux',
      furnitureChairs: 'Chaises / tabourets',
      furnitureTableSets: 'Ensembles table-chaises',
      furnitureBeds: 'Lits',
      furnitureCabinets: 'Rangement',
      furnitureStorage: 'Rangement',
      furnitureLighting: 'Éclairage',
      furnitureCushions: 'Coussins',
      furnitureClocks: 'Horloges',
      furnitureArtDecor: 'Art et décoration',
      furnitureMirrors: 'Miroirs',
      materialWallpaper: 'Revêtement mural',
      materialFlooring: 'Sol',
      other: 'Autres',
      kitchenBathCabinet: 'Placards',
      kitchenBathKitchen: 'Cuisine',
      kitchenBathEquipment: 'Équipement',
      kitchenBathVanity: 'Meuble vasque',
      kitchenBathSanitary: 'Sanitaires'
    },
    editorToolRequired: {
      wall: 'Mur',
      area: 'Zone de pièce',
      door: 'Porte',
      doorDouble: 'Double porte',
      slidingDoor: 'Porte coulissante',
      window: 'Fenêtre',
      sashWindow: 'Fenêtre à guillotine',
      gate: 'Portail',
      floorOpening: 'Ouverture de plancher',
      column: 'Poteau',
      columnSquare: 'Poteau carré',
      beam: 'Poutre',
      simpleStair: 'Escalier simple',
      sofa: 'Canapé',
      tables: 'Tables / tables basses',
      chairs: 'Tabourets / chaises',
      tableSets: 'Ensembles table-chaises',
      beds: 'Lits / ensembles de lit',
      cabinets: 'Meubles / étagères',
      kitchenCabinet: 'Placard de cuisine',
      kitchen: 'Cuisine',
      equipment: 'Équipement',
      bathroomVanity: 'Meuble vasque',
      sanitary: 'Sanitaires'
    },
    editorToolUnavailable: 'Non disponible',
    editorProperty: {
      emptyTitle: 'Aucune sélection',
      emptyHint: 'Sélectionnez un mur, une ouverture ou un meuble pour le modifier ici.'
    },
    wallSurfaceMaterial: {
      title: 'Matériau du mur',
      currentSide: 'Matériau du mur · {side}',
      sideA: 'A · Gauche dans le sens du mur',
      sideB: 'B · Droite dans le sens du mur',
      heading: 'Matériau du mur',
      sideAShort: 'Face A',
      sideBShort: 'Face B',
      sideGroup: 'Côté du mur',
      texture: 'Texture',
      color: 'Couleur',
      source: 'Source',
      clearSide: 'Effacer le remplacement de ce côté',
      sources: { surface: 'Remplacement du côté', legacy: 'Propriété du mur', theme: 'Valeur du thème' },
      textures: { bricks: 'Brique', painted: 'Mur peint' }
    },
    property: {
      clampedTo: 'Valeur ajustée à la plage {min}-{max}, valeur appliquée : {actual}',
      fittedToWall: 'Ajusté à {actual} pour tenir dans le mur'
    },
    editorBottom: {
      otherFloorOpacity: 'Opacité autres niveaux',
      showOtherFloors: 'Afficher les autres niveaux',
      hideOtherFloors: 'Masquer les autres niveaux',
      expand3d: 'Agrandir',
      previewInCanvas: 'L\'aperçu 3D est affiché dans le canevas principal',
      statistics: 'Statistiques'
    },
    aiRoomDesign: {
      title: 'Conception de Pièces IA',
      open: 'Pièces IA',
      selectedProduct: 'Produit sélectionné',
      noProduct: 'Aucun produit sélectionné',
      selectProduct: 'Choisir un produit',
      browseProducts: 'Parcourir les produits',
      layerCount: 'Étages',
      livingRoom: 'Salon',
      diningRoom: 'Salle à Manger',
      masterRoom: 'Chambre Principale',
      secondRoom: 'Chambre / Bureau',
      kitchen: 'Cuisine',
      bathroom: 'Salle de Bain',
      storage: 'Rangement',
      staircase: 'Escalier',
      notice1: 'L\'IA utilisera ces besoins comme référence, mais la composition finale des pièces est déterminée par l\'algorithme',
      notice2: 'La disposition générée sera alignée sur une grille modulaire de 455 mm et supprimera les portes et fenêtres existantes',
      elapsed: 'Temps écoulé',
      submit: 'Générer la Disposition des Pièces',
      needAtLeastOneRoom: 'Au moins une pièce est requise',
      successTitle: 'Disposition des Pièces Générée avec Succès'
    },
    aiWindowDesign: {
      title: 'Conception de Portes et Fenêtres IA',
      open: 'Portes/Fenêtres IA',
      roomCount: 'Nombre de Pièces Actuel',
      notice: 'Les portes et fenêtres seront générées pour tous les murs, les existantes seront remplacées',
      elapsed: 'Temps écoulé',
      submit: 'Générer Portes et Fenêtres',
      successTitle: 'Portes et Fenêtres Générées avec Succès',
      successMessage: '{doorCount} portes et {windowCount} fenêtres générées'
    },
    aiCandidatePreview: {
      previewTitle: 'Aperçu de la Conception IA',
      currentScene: 'Conception Actuelle',
      candidateScene: 'Conception Candidate IA',
      previewHint: 'Veuillez comparer les deux conceptions et confirmer pour appliquer',
      floorLabel: 'Étage',
      outlineDiffsTitle: 'Différences de Contour',
      layer: 'Étage',
      beforeSize: 'Taille Originale',
      afterSize: 'Taille IA',
      sizeChange: 'Changement de Taille',
      areaCoverage: 'Zone de Couverture',
      areaChange: 'Changement de Zone',
      applyRoomLabel: 'Appliquer la Conception de Pièces IA',
      applyWindowLabel: 'Appliquer la Conception de Portes et Fenêtres IA'
    },
    reportCapture: {
      title: 'Confirmer les images du rapport',
      stepFloors: 'Plans 2D',
      stepViews: 'Vues 3D',
      floorsHint: 'Vérifiez le plan de chaque étage. Les images sont capturées automatiquement selon le contenu.',
      viewsHint: 'Vérifiez les images des vues 3D. La vue actuelle sert d’image principale.',
      noFloors: 'Aucun étage disponible.',
      noContent: 'Cet étage n’a aucun contenu à afficher.',
      viewIdle: 'Pas encore capturé.',
      recapture: 'Recapturer',
      capture: 'Capturer',
      reframe: 'Sélectionner la zone',
      reframeCancel: 'Annuler la sélection',
      reframeHint: 'Faites glisser sur l’aperçu pour sélectionner la zone de capture.',
      zoomIn: 'Agrandir',
      zoomOut: 'Réduire',
      confirm: 'Confirmer',
      delete: 'Supprimer',
      next: 'Suivant : vues 3D',
      done: 'Terminer',
      cancel: 'Annuler',
      confirmIncomplete: 'Veuillez confirmer tous les plans d’étage et les cinq images 3D du rapport avant de terminer.',
      mainBadge: 'Principale',
      captureFailed: 'Échec de la capture d’écran.',
      statusIdle: 'Non capturé',
      statusCapturing: 'Capture en cours...',
      statusReady: 'En attente de confirmation',
      statusConfirmed: 'Confirmé',
      statusError: 'Erreur',
      summary: 'Confirmé : étages {floors}/{floorTotal} · 3D {views}',
      storageTrimmed: '{count} image(s) de vue 3D superflue(s) supprimée(s) pour le stockage local.',
      viewNames: {
        main: 'Vue principale',
        current: 'Vue actuelle',
        front: 'Face',
        back: 'Arrière',
        left: 'Gauche',
        right: 'Droite'
      }
    },
    reportAssetsMissing: {
      title: 'Images du rapport non confirmées',
      message: 'Ce projet n’a pas encore confirmé les plans d’étage et les images 3D du rapport. Vous pouvez d’abord confirmer les images, ou continuer l’export avec les ressources par défaut générées par le système.',
      confirmImages: 'Confirmer les images',
      useDefault: 'Continuer avec les ressources par défaut',
      cancel: 'Annuler'
    },
    reportAssetDefault: {
      generateFailed: 'Échec de la génération des ressources par défaut du rapport. Veuillez réessayer plus tard.',
      retry: 'Réessayer',
      missingFloorPlan: 'Plan(s) d’étage manquant(s)',
      missing3dView: 'Image(s) 3D du rapport manquante(s)',
      captureFailed: 'Échec de la capture d’écran'
    },
    shareLink: {
      title: 'Lien de partage',
      generating: 'Génération du lien de partage...',
      mockNotice: 'Ce lien est une démonstration. Le partage officiel sera activé après la connexion à l\'API backend.',
      copy: 'Copier le lien',
      copied: 'Copié',
      copyFailed: 'Échec de la copie. Veuillez copier manuellement.',
      error: 'Échec de la génération du lien de partage',
      retry: 'Réessayer',
      close: 'Fermer'
    },
    roomAreas: {
      dirtyHint: 'Les zones de pièces ont peut-être changé. Cliquez sur « Re-détecter les pièces » pour mettre à jour.',
      recompute: 'Re-détecter les pièces',
      recomputeSuccess: 'Zones de pièces re-détectées',
      recomputeFailed: 'Échec de la détection. Les zones existantes ont été conservées.',
      recomputeHistory: 'Re-détecter les pièces',
      metricsSummary: '{roomCount} pièces · {totalAreaM2} m² au total · {bedroomCount} chambres'
    },
    exportPdf: {
      success: 'Téléchargement PDF démarré',
      failed: 'Échec de l\'export PDF',
      mockNotice: 'PDF mock d\'exemple. Les rapports officiels arriveront en phase 2 (backend).',
      capturePartial: 'Certaines captures ont échoué ; l\'export continue sans bloquer l\'édition.'
    },
    exportHtml: {
      success: 'Rapport HTML exporté et ouvert dans un nouvel onglet',
      failed: 'Échec de l\'export HTML',
      mockNotice: 'Page HTML mock statique. La publication hébergée arrive en phase 2.',
      capturePartial: 'Certaines captures ont échoué ; l\'export continue sans bloquer l\'édition.'
    },
    deleteSelected: 'Supprimer la sélection',
    applyToSelection: 'Appliquer à la sélection',
    moveSelected: 'Déplacer la sélection',
    moveToFloor: 'Déplacer vers l\'étage',
    visible: 'Visible',
    unchanged: 'inchangé',
    warnings: 'Avertissements',
    errors: 'Erreurs',
    aiSubmitting: 'Envoi de la tâche IA...',
    aiProcessing: 'IA en cours · {seconds}s · sondage {attempt}',
    aiTodo: 'TODO : intégration du service IA intentionnellement désactivée.',
    featureDeveloping: 'Fonctionnalité en développement',
    savedLocally: 'Enregistré.',
    saveFailed: 'Les modifications actuelles n\'ont pas été enregistrées.',
    draftRestored: 'Brouillon d\'édition non enregistré restauré.',
    versionRestored: 'Version locale restaurée.',
    projectLoaded: 'Projet chargé.',
    invalidProjectJson: 'JSON du projet invalide.',
    importDialogTitle: 'Importer un JSON local',
    importAsNewHint: 'Sera importé comme un nouveau projet, sans affecter le projet actuel.',
    importStructureDecodeFailed: 'Les données de structure n\'ont pas pu être décodées ; seul le bâtiment a été importé.',
    importName: 'Nom du projet',
    importBudget: 'Budget (10k JPY)',
    importFrontage: 'Façade (ken)',
    importConfirm: 'Importer comme nouveau projet',
    importRequiredFields: 'Veuillez renseigner le nom du projet, le budget et la façade avant l\'importation.',
    importedAsNewProject: 'Importé comme nouveau projet.',
    groups: 'Groupes',
    floors: 'Étages',
    opacity: 'Opacité',
    currentFloor: 'Étage actuel',
    floorProperties: 'Propriétés de l\'étage',
    basicParams: 'Paramètres de base',
    layoutOpacity: 'Paramètres d\'affichage',
    deleteFloor: 'Supprimer l\'étage',
    deleteCurrentFloor: 'Supprimer l\'étage actuel',
    deleteFloorConfirmMessage: 'La suppression de cet étage effacera tout le contenu de conception qu\'il contient. Continuer ?',
    guides: 'Guides',
    newGroup: 'Nouveau groupe',
    addSelected: 'Ajouter la sélection',
    groupName: 'Nom du groupe',
    rotate: 'Pivoter',
    duplicate: 'Dupliquer',
    ungroup: 'Dissocier',
    deleteAll: 'Tout supprimer',
    removeFromGroup: 'Retirer du groupe',
    addFloor: 'Ajouter un étage',
    addUpperFloor: 'Ajouter un étage supérieur',
    addLowerFloor: 'Ajouter un étage inférieur',
    deleteFloorButton: 'Supprimer l\'étage actuel',
    floorInsertPosition: 'Position d\'insertion',
    floorPositionAbove: 'Au-dessus de l\'étage actuel',
    floorPositionBelow: 'En dessous de l\'étage actuel',
    floorName: 'Nom de l\'étage',
    copyStructure: 'Copier la structure du plan de l\'étage actuel',
    confirm: 'Confirmer',
    duplicateFloor: 'Dupliquer l\'étage',
    selectAllFloor: 'Tout',
    selectAllFloorElements: 'Sélectionner tous les éléments de l\'étage',
    lock: 'Verrouiller',
    altitude: 'Altitude',
    floorHeight: 'Hauteur d\'étage',
    slabThickness: 'Épaisseur de dalle',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    addSelectedElement: 'Ajouter l\'élément sélectionné',
    noVersions: 'Aucune version enregistrée manuellement.',
    restore: 'Restaurer',
    localVersions: 'Versions locales',
    sceneWidth: 'Largeur de scène ({unit})',
    sceneHeight: 'Hauteur de scène ({unit})',
    name: 'Nom',
    description: 'Description',
    unit: 'Unité',
    familySize: 'Taille du foyer',
    style: 'Style',
    budget: 'Budget',
    daylightPriority: 'Priorité à la lumière du jour',
    notes: 'Notes',
    roomRequirements: 'Exigences des pièces',
    roomRelationships: 'Relations entre pièces',
    fromRoom: 'Pièce de départ',
    toRoom: "Pièce d'arrivée",
    add: 'Ajouter',
    aiServiceTodo: 'TODO : service IA',
    rooms: {
      living_room: 'Salon',
      bedroom: 'Chambre',
      kitchen: 'Cuisine',
      bathroom: 'Salle de bain',
      dining_room: 'Salle à manger'
    },
    styles: {
      modern: 'moderne',
      minimal: 'minimal',
      classic: 'classique',
      industrial: 'industriel'
    },
    budgets: {
      economy: 'économique',
      standard: 'standard',
      premium: 'premium'
    },
    roomStatistics: {
      title: 'Statistiques des pièces',
      scope: 'Portée',
      allFloors: 'Tous les étages',
      unnamedOrUnrecognized: 'Sans nom / non reconnue',
      roomType: 'Type de pièce',
      roomCount: 'Nombre',
      totalRooms: 'Total pièces',
      totalArea: 'Surface totale',
      calculating: 'Calcul en cours',
      refreshing: 'Mise à jour',
      stale: 'Données potentiellement obsolètes',
      recompute: 'Recalculer les surfaces',
       noData: 'Aucune statistique disponible'
     },
     aiStructure: {
       entry: 'Génération structurelle IA',
       modes: {
         label: 'Mode d’affichage',
         architecture: 'Architecture',
         structure: 'Structure'
       },
       overlay: {
         showBuilding: 'Afficher le fond architectural',
         hideBuilding: 'Masquer le fond architectural',
         opacity: 'Opacité du fond architectural'
       },
       plans: {
         label: 'Plan structurel',
         foundation: 'Plan de structure du premier étage',
         'beam-column': 'Plan de charpente de toiture {floor}',
         'bearing-wall': 'Plan d’implantation des murs porteurs {floor}'
       },
       lineModes: {
         label: 'Mode de dessin',
         line: 'Ligne',
         fixedWidth: 'Ligne à largeur fixe',
         cappedLine: 'Ligne avec extrémités'
       },
       messages: {
         readOnly: 'Ce mode d’affichage est en lecture seule.',
         applied: 'La proposition structurelle a été appliquée.'
       },
       errors: {
         system: 'Impossible de récupérer les données structurelles. Veuillez réessayer.',
         unavailable: 'Les données structurelles sont indisponibles. Veuillez générer à nouveau.',
         readOnly: 'Ce mode d’affichage est en lecture seule.'
       },
       properties: {
         title: 'Propriétés de l’élément structurel',
         empty: 'Sélectionnez un élément structurel pour afficher ses propriétés en lecture seule.',
         layer: 'Niveau',
         type: 'Type',
         role: 'Rôle',
         section: 'Section',
         elevation: 'Élévation',
         hostWall: 'Mur hôte',
         wallSpecification: 'Spécification du mur'
       }
     },
     mechanicsCheck: {
       historyUnlinked: "Les anciennes vérifications ne sont pas liées à une structure. Relancez la vérification.",
       runningPrevious: "Une nouvelle vérification est en cours. Le résultat précédent est affiché.",
       latestFailedPrevious: "La dernière vérification a échoué. Le résultat précédent est affiché.",
       recoveryFailed: "Impossible de charger le résultat distant. Actualisez pour réessayer.",
       recoveryUnlinked: "Le lien avec la tâche de structure est introuvable. Régénérez la structure avant la vérification.",
       showFailures: 'Afficher les éléments non conformes',
       hideFailures: 'Masquer la surbrillance',
       detailTitle: 'Détails de non-conformité',
       detailEmpty: 'Aucun détail fourni dans le résultat.',
       entry: 'Vérification mécanique',
       requiresStructure: 'Générez d’abord la structure IA.',
       started: 'La vérification mécanique a commencé.',
       completed: 'La vérification mécanique est terminée.',
       failed: 'La vérification mécanique a échoué. Veuillez réessayer.',
       resultTitle: 'Résultat de la vérification mécanique',
       resultLoading: 'Vérification mécanique en cours…',
       resultPreparing: 'Chargement du résultat de la vérification…',
       resultPreparingDescription: 'Le calcul est terminé. Les fichiers de résultat sont en cours de chargement.',
       resultEmpty: 'Aucune vérification mécanique n’a encore été effectuée.',
       statusDescription: 'En attente du résultat. La structure actuelle reste affichée.'
     }
   },
  designEvaluation: {
    entry: 'Évaluation de la conception',
    dialogTitle: 'Évaluation de la conception',
    planPreviewLabel: 'Plan',
    previewLoading: 'Génération du plan en cours',
    previewFailed: 'Échec de la génération du plan de cet étage',
    retryPreview: 'Réessayer',
    designNotReady: 'Veuillez d\'abord terminer la conception IA',
    backendUnavailable: 'La fonction d\'évaluation n\'est pas disponible pour le moment',
    scoreLabel: 'Note',
    scoreRequired: 'Veuillez sélectionner une note de 1 à 10',
    scoreAriaHint: 'Note de 1 à 10',
    commentLabel: 'Commentaire',
    commentPlaceholder: 'Saisissez votre évaluation',
    commentCounter: '{count} / 1000',
    submissionNotice: 'Les plans sont uniquement destinés à la confirmation ; seuls l\'ID de conception, la note et le commentaire sont envoyés',
    submit: 'Envoyer l\'évaluation',
    cancel: 'Annuler',
    submitting: 'Envoi en cours',
    successMsg: 'Évaluation enregistrée',
    errorScore: 'Note invalide, veuillez choisir un entier de 1 à 10',
    errorCommentTooLong: 'Le commentaire dépasse 1000 caractères',
    errorForbidden: 'Ce compte n\'a pas l\'autorisation d\'évaluer',
    errorNotFound: 'La conception n\'existe pas ou n\'est pas accessible',
    errorNotReady: 'La conception IA n\'est pas encore terminée',
    errorRateLimited: 'Envois trop fréquents, veuillez réessayer plus tard',
    errorInternal: 'Échec de l\'envoi, veuillez réessayer plus tard',
    errorGeneric: 'Échec de l\'envoi'
  },
  floorplan: {
    categories: {
      lines: 'Murs',
      holes: 'Portes / Fenêtres',
      structure: 'Structure',
      furnishings: 'Ameublement',
      items: 'Éléments',
      areas: 'Zones'
    },
    elements: {
      wall: 'Mur',
      "door": "Porte battante simple",
      "door-double": "Porte battante double",
      "door-parent-child": "Porte tiercée",
      "sliding-door": "Porte coulissante double",
      "door-pocket": "Porte coulissante intérieure",
      "door-surface-sliding": "Porte coulissante extérieure",
      "door-folding": "Porte pliante",
      "window": "Fenêtre coulissante",
      "window-fixed": "Fenêtre fixe",
      "window-side-hung": "Fenêtre battante",
      "window-casement": "Fenêtre à projection latérale",
      "window-awning": "Fenêtre à soufflet extérieur",
      split: 'Ouverture',
      sofa: 'Canapé',
      bed: 'Lit',
      chair: 'Chaise',
      bench: 'Banc',
      'dining-table': 'Table à manger',
      'round-table': 'Table ronde',
      'low-table': 'Table basse',
      desk: 'Bureau',
      'side-table': 'Table d\'appoint',
      console: 'Console',
      shelf: 'Étagère',
      cabinet: 'Meuble',
      'clothes-rack': 'Portant',
      'tv-board': 'Meuble TV',
      refrigerator: 'Réfrigérateur',
      kitchen: 'Cuisine',
      toilet: 'WC',
      bathtub: 'Baignoire',
      washbasin: 'Lavabo',
      'washing-machine': 'Lave-linge',
      'shoe-cabinet': 'Meuble à chaussures',
      stair: 'Escalier',
      'sofa-B': 'Canapé B',
      'chair-A': 'Chaise A',
      'chair-B': 'Chaise B',
      column: 'Poteau',
      beam: 'Poutre',
      'floor-opening': 'Ouverture de plancher',
      'ceiling-opening': 'Vide sous plafond',
      'ceiling-drop': 'Plafond abaissé',
      'column-square': 'Poteau carré',
      'independent-column': 'Poteau isolé',
      'fridge-A': 'Réfrigérateur A',
      'simple-stair': 'Escalier droit',
      'stair-l': 'Escalier en L',
      'stair-u': 'Escalier en U',
      'stair-c': 'Escalier à trois volées',
      'tv-board-A': 'Meuble TV A',
      'tv-board-B': 'Meuble TV B',
      area: 'Zone de pièce'
    },
    attributes: {
      name: 'Nom',
      visible: 'Visible',
      x: 'X',
      y: 'Y',
      rotation: 'Angle',
      offset: 'Position',
      catalogItemId: 'ID catalogue',
      modelId: 'ID modèle',
      textureId: 'ID texture',
      materialId: 'ID matériau',
      displayName: 'Nom affiché',
      computedAreaM2: 'Surface (m²)',
      computedAreaTsubo: 'Surface (tsubo)'
    },
    properties: {
      type: "Type",
      hinge: "Côté des charnières",
      swing: "Ouverture",
      registeredSize: "Dimension enregistrée",
      foldingPanels: "Vantaux",
      handleStyle: "Poignée",
      finish: 'Finition',
      beamDepth: 'Retombée de poutre',
      dropDepth: 'Retombée',
      openingWidth: "Largeur d'ouverture",
      storageSide: "Côté de rangement",
      mountSide: "Face de pose",
      pocketSlotSide: "Côté de la niche",

      size: 'Dimensions',
      basicParams: 'Paramètres de base',
      dimensionParams: 'Dimensions',
      roomName: 'Nom de la pièce',
      sizeVariant: 'Taille',
      selectedMaterial: 'Sélection',
      searchMaterial: 'Filtrer par nom',
      noMaterialMatch: 'Aucun matériau correspondant',
      manufacturer: 'Marque',
      width: 'Largeur',
      depth: 'Profondeur',
      height: 'Hauteur',
      length: 'Longueur',
      thickness: 'Épaisseur',
      floorDistance: 'Distance au sol',
      topHeight: 'Hauteur du haut',
      lighting: 'Éclairage',
      lightOnEvening: 'Allumer dès le soir',
      floorElevation: 'Décalage du sol',
      elevation: 'Élévation',
      color: 'Couleur',
      material: 'Matériau',
      texture: 'Texture',
      texturePreview: 'Aperçu de texture',
      rotation: 'Angle',
      offset: 'Position',
      open: 'Ouvert',
      flip_orizzontal: 'Inverser',
      position: 'Position'
    },
    beamFinishes: {
      wood: 'Bois (poutre apparente)',
      wallpaper: 'Papier peint (poutre habillée)'
    },
    handleStyles: {
      lever: "Béquille",
      knob: "Bouton",
      pull: "Poignée",
      bar: "Barre",
      recessed: "Poignée encastrée",
      none: "Aucune"
    },
    fittingOptions: {
      panelCount: '{n} vantaux',
      left: "Gauche",
      right: "Droite",
      in: "Intérieur",
      out: "Extérieur",
      storageLeft: "Rangement à gauche",
      storageRight: "Rangement à droite",
      mountIn: "Face intérieure",
      mountOut: "Face extérieure",
      slotIn: "Côté intérieur",
      slotOut: "Côté extérieur"
    },
    textures: {
      plain: 'Couleur unie',
      default: 'Non défini',
      bricks: 'Briques',
      painted: 'Peint',
      wood: 'Bois',
      tile: 'Carrelage',
      tatami: 'Tatami',
      concrete: 'Béton',
      none: 'Aucun'
    },
    materials: {
      fabric: 'Tissu',
      wood: 'Bois',
      metal: 'Métal',
      glass: 'Verre',
      plastic: 'Plastique'
    }
  },
  errors: {
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
    requestFailed: 'Échec de la requête',
    aiDesignNetworkError: 'Erreur réseau, veuillez vérifier votre connexion',
    aiDesignTimeout: 'Délai de conception dépassé, veuillez réessayer plus tard',
    aiDesignServiceError: 'Service temporairement indisponible',
    aiDesignValidationError: 'Échec de la validation de l\'entrée',
    aiDesignPartitionFailed: 'Impossible de générer les pièces initiales à partir du contour actuel, veuillez ajuster le contour et réessayer',
    aiDesignOutlineShrunk: 'L\'IA a retourné une zone de bâtiment plus petite que le contour original, résultat abandonné',
    aiDesignParseError: 'Erreur de format de résultat',
    aiDesign: {
      VALIDATION_ERROR: 'Échec de la validation des données',
      NETWORK_ERROR: 'Échec de la connexion réseau',
      TIMEOUT: 'Délai d\'exécution du service dépassé',
      REMOTE_SERVICE_ERROR: 'Le service IA a retourné une erreur',
      PARSE_ERROR: 'Impossible d\'analyser le package téléchargé ou le JSON',
      PARTITION_FAILED: 'La disposition actuelle des murs ne peut pas former une entrée IA complète',
      OUTLINE_SHRUNK: 'Le contour du bâtiment a changé',
      AI_RESULT_INVALID: 'L\'IA a retourné une structure invalide',
      AI_RESULT_STATS_MISMATCH: 'Les statistiques backend sont incohérentes avec les portes/fenêtres réelles',
      AI_ELEMENT_GEOMETRY_CHANGED: 'La phase portes/fenêtres a modifié les murs ou les pièces',
      AI_SOURCE_SCENE_CHANGED: 'Le plan a changé, la conception candidate est obsolète',
      APPLY_FAILED: 'Échec de l\'application de la conception IA',
      UNKNOWN: 'Erreur inconnue'
    }
  },
  reportStudio: {
    entry: 'Studio d\'images',
    back: 'Retour à l\'éditeur',
    save: 'Enregistrer',
    saveSuccess: 'Assets du rapport enregistrés',
    saveFailed: 'Échec de l\'enregistrement des assets. Veuillez réessayer.',
    saveStatusUnsaved: 'Non enregistré',
    saveStatusSaved: 'Enregistré',
    canvasPlaceholder: '{type} — à venir',
    settingsPlaceholder: 'Panneau de réglages (à venir)',
    assetRailPlaceholder: 'Bandeau d\'assets (à venir)',
    types: {
      layout: 'Plan de disposition',
      floorPlan: 'Plan d\'étage',
      render: 'Rendu 3D',
      elevation: 'Élévation'
    },
    rail: {
      title: 'Assets enregistrés',
      empty: 'Aucun asset enregistré pour ce type',
      delete: 'Supprimer',
      confirmForReport: 'Confirmer pour le rapport PDF/HTML',
      confirmedForReport: 'Confirmé pour PDF/HTML',
      statusPreview: 'Aperçu non confirmé',
      statusMissing: 'Manquant / en attente',
      slots: {
        layout: 'Plan de disposition',
        floorPlan: 'Étage {layer}',
        renderMain: 'Vue principale',
        renderSubTop: 'Sous-vue (haut)',
        renderSubBottom: 'Sous-vue (bas)',
        elevationFront: 'Façade avant',
        elevationBack: 'Façade arrière',
        elevationLeft: 'Gauche',
        elevationRight: 'Droite'
      }
    },
    render: {
      renderType: 'Type de rendu',
      renderTypeScreenshot: 'Capture actuelle',
      aiRender: 'Rendu IA',
      aiRenderPending: 'Interface en attente de connexion',
      cameraPresets: 'Préréglages de vue',
      presets: {
        'oblique-front': 'Vue oblique avant',
        aerial: 'Vue aérienne'
      },
      renderStyle: 'Style de rendu',
      renderStylePlaceholder: 'Bientôt disponible',
      aspectRatio: 'Format d\'image',
      aspectRatioPlaceholder: 'Bientôt disponible',
      saveCurrentView: 'Enregistrer la vue actuelle',
      saveAsMain: 'Enregistrer comme principale',
      saveAsSubTop: 'Enregistrer comme sous-vue (haut)',
      saveAsSubBottom: 'Enregistrer comme sous-vue (bas)',
      resetCamera: 'Réinitialiser la vue',
      captureFailed: 'Échec de la capture 3D'
    },
    elevation: {
      direction: 'Direction',
      directions: {
        front: 'Façade avant',
        back: 'Façade arrière',
        left: 'Côté gauche',
        right: 'Côté droit'
      },
      layoutMode: 'Mode de mise en page',
      layoutModeSingle: 'Vue unique',
      layoutModeOverview: 'Vue d\'ensemble (4 faces)',
      saveCurrentView: 'Enregistrer la vue orthographique',
      saveDirection: 'Enregistrer {direction}',
      unsaved: 'Non enregistré',
      backToOverview: 'Retour à la vue d\'ensemble',
      resetCamera: 'Réinitialiser la vue',
      captureFailed: 'Échec de la capture 3D',
      generateSingleViewPreview: 'Générer l\'aperçu d\'une vue unique'
    },
    confirm: {
      replaceTitle: 'Remplacer l\'image confirmée',
      replaceMessage: 'Cet asset est confirmé pour le rapport PDF/HTML. Le remplacer par une nouvelle image ?',
      deleteTitle: 'Supprimer l\'asset du rapport',
      deleteMessage: 'Le rapport n\'aura plus cet asset après suppression. Continuer ?',
      noPreview: 'Générez ou sélectionnez d\'abord une image à gauche',
      confirmButton: 'Confirmer'
    },
    capture: {
      deprecatedGuard: 'Ce dialogue n\'est plus sur le chemin d\'export de production. Confirmez les assets dans le studio avant d\'exporter.'
    },
    layout: {
      imageSource: 'Source de l\'image',
      upload: 'Téléverser une image',
      pickExisting: 'Choisir une image existante',
      pickEmpty: 'Aucune image disponible',
      fitMode: 'Mode d\'ajustement',
      fitWidth: 'Ajuster à la largeur',
      fitHeight: 'Ajuster à la hauteur',
      fitPage: 'Ajuster à la page',
      saveLayout: 'Enregistrer le plan de disposition',
      noImageSelected: 'Téléversez ou choisissez une image',
      canvasEmpty: 'Aperçu page blanche (aucune image)',
      zoomIn: 'Zoom avant',
      zoomOut: 'Zoom arrière',
      uploadFailed: 'Échec de la lecture de l\'image',
      uploadInvalidType: 'Veuillez sélectionner un fichier image'
    },
    floorPlan: {
      floorSwitch: 'Étage',
      visibility: 'Affichage',
      showTotalDimensions: 'Dimensions globales',
      showSegmentDimensions: 'Dimensions segmentées',
      showRoomNames: 'Noms des pièces',
      showRoomAreas: 'Surfaces des pièces',
      showFurniture: 'Mobilier',
      showHoles: 'Portes et fenêtres',
      dimensionActions: 'Outils de cote',
      autoGenerate: 'Génération auto',
      addManual: 'Ajouter manuellement',
      cancelManualAdd: 'Annuler l\'ajout',
      deleteSelected: 'Supprimer la sélection',
      hideSelected: 'Masquer la sélection',
      regenerateAll: 'Tout régénérer',
      resetOffsets: 'Réinitialiser les offsets',
      roomLabelActions: 'Étiquettes de pièce',
      toggleRoomLabels: 'Afficher/masquer les étiquettes',
      resetRoomLabelPositions: 'Réinitialiser les positions',
      saveCurrentFloor: 'Enregistrer l\'étage actuel comme ressource',
      captureFailed: 'Échec de la capture 2D',
      noChainSelected: 'Sélectionnez d\'abord une chaîne de cote',
      manualAddHint: 'Cliquez deux points sur le plan dans l\'ordre',
      manualAddInvalid: 'Seules les cotes horizontales/verticales sont prises en charge',
      noDimensionBounds: 'L\'étage actuel n\'a pas de contour pour générer des cotes'
    }
  },
  reportExportConfirm: {
    title: {
      pdf: 'Confirmation d\'export du rapport PDF',
      html: 'Confirmation d\'export du rapport HTML'
    },
    generatePdf: 'Générer le rapport PDF',
    generateHtml: 'Générer le rapport HTML',
    optionalBadge: 'Facultatif',
    missingHint: '{count} asset(s) requis manquant(s) ou en attente de confirmation. Complétez-les avant de générer.',
    optionalMissingHint: 'Le plan de disposition est facultatif ; son absence ne bloque pas la génération.',
    openStudioHint: 'Cliquer pour ouvrir le studio et confirmer',
    statusConfirmed: 'Confirmé',
    statusPreview: 'En attente',
    statusMissing: 'Manquant / en attente'
  },
  // P06: textes UI conception IA asynchrone (aligner P01–P05/P07 ; distinct de errors.aiDesign)
  aiDesign: {
    fields: {
      productType: 'ProductType (nom du projet)',
      totalArea: 'TotalArea (tsubo)',
      layers: 'Layers (étages)',
      widthKen: 'WidthKen (façade)',
      unitPrice: 'Prix unitaire par tsubo',
      unitPriceValue: '{count} man-yen / tsubo',
      totalAreaValue: '{count} tsubo',
      budget: 'Budget',
      frontage: 'Façade',
      projectName: 'Nom du projet',
      algorithm: 'Algorithme'
    },
    algorithms: {
      floorplan_diffusion: 'Modèle de diffusion',
      floorplan_gpt_image_2: 'VLM',
      floorplan_gpt6: 'LLM Agent',
      building_element_diffusion: 'Ouvertures Diffusion',
      building_element_rule: 'Ouvertures Règle'
    },
    status: {
      queued: 'En file d\'attente',
      generating: 'Génération en cours',
      completed: 'Terminé',
      failed: 'Échec de la génération',
      waitedTime: 'Attente de {seconds} s',
      canLeavePage: 'Vous pouvez quitter cette page'
    },
    actions: {
      abandonTask: 'Abandonner la tâche',
      abandonConfirm: 'Abandonner la tâche « {name} » ? Les résultats ne seront plus affichés ni appliqués.',
      viewNewPlan: 'Voir le nouveau plan',
      confirmReplace: 'Confirmer le remplacement',
      retrySameParams: 'Réessayer avec les paramètres d\'origine'
    },
    waiting: {
      editLocked: 'L\'édition est verrouillée pendant la génération. La tâche continue en arrière-plan ; vous pouvez quitter cette page et revenir plus tard.',
    },
    messages: {
      floorplanChanged: 'Le plan actuel a changé',
      regenerateWindows: 'Veuillez régénérer les portes et fenêtres',
      busy: 'Le service est occupé. Veuillez réessayer plus tard.',
      taskRecordCorrupted: 'L\'enregistrement de la tâche est corrompu',
      resultInvalid: 'Résultat invalide'
    },
    projectCard: {
      generating: 'Génération',
      completed: 'Terminé',
      failed: 'Échec'
    },
    validation: {
      budget: 'Le budget doit être un entier entre 500 et 3500 (man-yen)',
      input: 'Entrée invalide',
      projectName: 'Veuillez saisir un nom de projet',
      frontage: 'La façade doit être entre 2 et 5 ken par pas de 0,5',
      layers: 'Le nombre d\'étages doit être 1–3',
      algorithm: 'L\'algorithme sélectionné n\'est pas autorisé pour ce type de conception'
    }
  },
  drawingVectorize: {
    editor: {
      loadFailed: 'Impossible de charger le plan calibré. Veuillez réessayer.',
      rescale: 'Échelle',
      autosaveOn: 'Enregistrement auto',
      autosaveSaving: 'Enregistrement…',
      autosaveSaved: 'Enregistré',
      autosaveFailed: 'Échec de l’enregistrement',
      furnitureArriving: 'Placement du mobilier…',
      furnitureFailed: 'Le mobilier n’a pas pu être lu. Vous pouvez quand même modifier les pièces',
      reupload: 'Régénérer',
      reuploadConfirm: 'Retour à l’écran d’import.'
    },
    rescale: {
      title: 'Modifier l’échelle',
      gridTitle: 'Petite grille',
      gridHint: 'Taille de la grille sur laquelle les murs s’alignent.',
      warning: 'Changer l’échelle annule vos modifications dans l’éditeur.',
      apply: 'Reconstruire à cette échelle',
      confirm: 'Reconstruire avec cette échelle ?',
      done: 'Échelle modifiée'
    },
    upload: {
      title: 'Importer depuis un plan',
      handDrawnTitle: 'Téléverser un plan dessiné à la main',
      subtitle: 'Téléversez un plan : murs, ouvertures et pièces sont détectés automatiquement. Si le plan comporte des cotes, l’échelle en est déduite automatiquement ; sinon, cliquez sur un mur dont vous connaissez la longueur réelle pour fixer l’échelle.',
      dropTitle: 'Téléverser un plan',
      dropMain: 'Déposez votre plan ici',
      dropSub: 'Glissez-déposez une image ou un document, ou cliquez ici pour choisir un fichier',
      page: 'Page du PDF',
      pdfSelectTitle: 'Choisissez la page a analyser',
      pdfLoading: 'Chargement des pages du PDF...',
      pdfFailed: 'Apercu du PDF impossible. Indiquez le numero de page.',
      pdfPageLabel: 'Page {page}',
      pdfPageCount: '{count} pages',
      pdfTooManyPages: 'Seules les {max} premieres pages sont affichees.',
      accepted: 'PNG / JPEG / TIFF / PDF, 5 Mo maximum',
      tooLarge: 'Le fichier dépasse 5 Mo',
      start: 'Lancer la reconnaissance',
      cancel: 'Annuler',
      stopWaiting: 'Arrêter l’attente',
      retry: 'Réessayer',
      detail: 'Détails',
      projectName: 'Nom du projet',
      apply: 'Ouvrir dans l’éditeur',
      reupload: 'Téléverser un autre plan',
      backToEditor: 'Retour à l’éditeur',
      sourceTitle: 'Plan téléversé',
      sourceOpen: 'Cliquer pour agrandir',
      sourceClose: 'Fermer',
      removeFile: 'Retirer le plan importé',
      regionHint: 'Faites glisser le cadre pour choisir la zone à lire.',
      regionReset: 'Revenir à la page entière',
      reading: 'Lecture du plan…',
      restoring: 'Chargement du dernier plan…',
      restoreFailed: 'Impossible de charger le dernier plan. Importez-le à nouveau.',
      sourceNoPreview: 'Le PDF ne peut pas être prévisualisé ici.'
    },
    progress: {
      uploading: 'Envoi du plan en cours',
      queued: 'En file d’attente',
      recognizing: 'Reconnaissance en cours',
      backgroundNotice: 'La reconnaissance continue même si vous quittez cette page.'
    },
    calibrate: {
      title: 'Calibrage de l’échelle',
      badgeCalibrated: 'Calibrée',
      badgeUncalibrated: 'Non calibrée',
      assumedNotice: 'Saisissez la dimension correcte',
      pickPrompt: 'Cliquez sur un mur dont vous connaissez la longueur réelle.',
      wholeWall: 'D’axe en axe',
      wholeWallUnavailable: 'Ce segment n’a pas de mur d’origine enregistré : seul le segment est mesuré.',
      currentLength: 'Longueur actuelle',
      currentLengthValue: 'environ {mm} mm ({px} px)',
      inputPlaceholder: 'Longueur réelle en millimètres',
      submit: 'Calibrer',
      submitting: 'Calcul…',
      result: '{mmPerPx} mm/px / référence : {reference}',
      badgeAuto: 'Automatique',
      badgeSuggested: 'À vérifier',
      autoTitle: 'L’échelle a été définie automatiquement à partir des cotes du plan.',
      suggestedTitle: 'L’échelle a été estimée à partir des cotes du plan. Vérifiez-la avant de la valider.',
      reasons: {
        single_orientation: 'Seules des cotes horizontales ou verticales ont pu être lues.',
        orientation_disagree: 'Les cotes horizontales et verticales donnent des échelles différentes.',
        no_long_baseline: 'Aucune cote couvrant tout le bâtiment n’a pu être lue.',
        few_inliers: 'Trop peu de cotes concordent entre elles.',
        low_agreement: 'Les cotes lues divergent trop entre elles.'
      },
      extentValue: 'Emprise du bâtiment : environ {width} m × {height} m',
      acceptEstimate: 'Valider cette échelle',
      pickPromptOverride: 'Si elle est fausse, cliquez sur un mur dont vous connaissez la longueur réelle et saisissez-la.',
      overridden: 'Modifiée par rapport à l’échelle définie automatiquement à partir des cotes ({mmPerPx} mm/px).',
      revertToEstimate: 'Revenir à l’échelle automatique',
      referenceDimensions: 'cotes du plan'
    },
    quality: {
      title: 'À vérifier',
      adjustment: 'Ajustement « {action} » : {count}',
      // 楼梯识别的调整记录。没有对应文案的动作码仍原样显示（见 WizardImportDrawingView）。
      actions: {
        area_relabelled_staircase: 'Pièce changée en cage d’escalier (escalier dessiné)',
        stair_synthesized_from_area: 'Escalier placé automatiquement (escalier non détecté)',
        stair_form_inferred: 'Forme de l’escalier déduite de la pièce',
        stair_direction_inferred: 'Sens de montée déduit',
        stair_facing_conflicts_footprint: 'Sens contraire à l’emprise ; orientation modifiée',
        stair_form_conflicts_footprint: 'Forme contraire à l’emprise ; déduite de la pièce',
        stair_area_not_rectangular: 'Cage d’escalier non rectangulaire',
        stair_footprint_fallback_to_preset: 'Taille d’escalier standard utilisée',
        stair_footprint_from_detection: 'Pièce avec un angle manquant : emprise de l’escalier prise du cadre détecté (escalier au-dessus d’un placard)',
        stair_footprint_from_room_label: 'Emprise prise du cadre de la pièce (cadre détecté trop petit)',
        stair_clamped_to_min_footprint: 'Pièce trop petite ; taille minimale utilisée',
        stair_overflows_area: 'L’escalier dépasse de la pièce',
        stair_without_area: 'Escalier hors de toute pièce',
        stair_dropped_at_placement: 'Escalier non placé',
        staircase_area_without_stair: 'Cage trop grande ou trop petite ; aucun escalier placé',
        staircase_label_ignored: 'Grande pièce marquée seulement UP / DN : pas une cage d’escalier',
        stair_opening_added: 'Ouverture percée dans le mur au départ de l’escalier (d’après son orientation)',
        stair_opening_skipped_exterior: 'Départ de l’escalier face à un mur extérieur : pas d’ouverture (vérifier l’orientation)',
        stair_opening_skipped_room: 'Départ de l’escalier face à une pièce d’eau, un rangement ou une chambre : pas d’ouverture (vérifier l’orientation)',
        stair_opening_skipped_narrow: 'Mur au départ de l’escalier trop court pour une ouverture',
        stair_orientation_from_start: 'Orientation de l’escalier corrigée d’après le départ de la ligne de foulée (départ UP / DN)',
        stair_direction_from_neighbour: 'Orientation de l’escalier déduite de la pièce devant son départ',
        furniture_outside_building_dropped: 'Meubles éloignés du bâtiment retirés (en général détectés à tort sur une perspective de la même page)',
        floor_level_from_drawing: 'Dénivelés de sol définis d’après les niveaux indiqués sur le plan (1FL-200, +300, etc.)',
        floor_level_assumed_from_name: 'Hauteur des demi-niveaux et estrades fixée par défaut (aucune hauteur sur le plan, à vérifier dans l’éditeur)',
        floor_boundaries_split_rooms: 'Pièces séparées le long des marches et garde-corps (pas des murs)',
        stair_room_carved: 'L’escalier partageait l’espace de la pièce voisine et a été découpé en pièce distincte',
        column_dropped: 'Poteaux candidats non placés (taille, dans un mur ou un meuble)'
      },
      unmatchedRooms: 'Pièces sans face associée : {names}',
      reviewRequired: 'Une vérification manuelle est recommandée.',
      adviceOnly: 'Vous pouvez les corriger dans l’éditeur.'
    },
    errors: {
      DRAWING_VECTORIZE_BUSY: 'Service de reconnaissance saturé. Réessayez dans environ {seconds} s.',
      DRAWING_VECTORIZE_FAILED: 'Échec de la reconnaissance. Réessayez plus tard.',
      DRAWING_INPUT_UNSUPPORTED: 'Fichier non pris en charge. Choisissez PNG / JPEG / TIFF / PDF, 5 Mo maximum.',
      DRAWING_CALIBRATION_INVALID: 'Cette longueur ne permet pas de calibrer. Essayez un autre mur ou vérifiez la cote.',
      DRAWING_SCENE_REJECTED: 'Le résultat n’a pas pu être chargé dans l’éditeur.',
      TIMEOUT: 'Délai dépassé. Réessayez.',
      NETWORK_ERROR: 'Réseau injoignable.',
      REMOTE_SERVICE_ERROR: 'Le service a renvoyé une erreur.',
      VALIDATION_ERROR: 'Vérifiez votre saisie.',
      STORAGE_WRITE_FAILED: 'Échec de l’enregistrement.',
      NAME_REQUIRED: 'Saisissez un nom de projet.',
      NOT_CALIBRATED: 'L’échelle n’est pas calibrée. Saisissez d’abord une longueur réelle.',
      IMPORT_FAILED: 'Impossible de créer le projet.',
      DRAWING_JOB_SUBMIT_FAILED: 'Impossible de lancer la reconnaissance. Veuillez réessayer.',
      DRAWING_JOB_NOT_FOUND: 'Cette tâche de reconnaissance est introuvable. Veuillez la relancer.',
      DRAWING_JOB_FAILED: 'La reconnaissance a échoué. Veuillez réessayer.',
      DRAWING_JOB_TIMEOUT: 'Délai d’attente dépassé. Le traitement est peut-être toujours en cours ; réessayez dans un instant.',
      DRAWING_RESULT_NOT_READY: 'Le résultat n’est pas encore prêt. Veuillez patienter.',
      UNKNOWN: 'Une erreur inconnue est survenue.'
    }
  },
  el: elementLocale.el
}
